module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "积分兑换"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "classHourForm",
    staticClass: "form",
    attrs: {
      "label-width": 100,
      "model": _vm.param,
      "rules": _vm.classHourRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 100,
      "label": "赠课类型",
      "prop": "givingType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.param.giveType),
      callback: function($$v) {
        _vm.$set(_vm.param, "giveType", _vm._n($$v))
      },
      expression: "param.giveType"
    }
  }, [_c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("课时赠送")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("物品赠送")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "积分扣除",
      "prop": "activity"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.param.activity),
      callback: function($$v) {
        _vm.$set(_vm.param, "activity", _vm._n($$v))
      },
      expression: "param.activity"
    }
  })], 1)], 1), _vm._v(" "), (_vm.param.giveType === 1) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "赠课次数",
      "prop": "lessonNum"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.param.lessonNum),
      callback: function($$v) {
        _vm.$set(_vm.param, "lessonNum", _vm._n($$v))
      },
      expression: "param.lessonNum"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.param.giveType === 2) ? _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "物品备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 3
      },
      "maxlength": 100,
      "placeholder": "长度不要超过100个字符"
    },
    model: {
      value: (_vm.param.remark),
      callback: function($$v) {
        _vm.$set(_vm.param, "remark", $$v)
      },
      expression: "param.remark"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingUpdate
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("保存")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27b81a1c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserActivityNumModal.vue
// module id = 1709
// module chunks = 8